(function () {
  var STORAGE_KEY = 'um_selected_model';
  var SHOW_ALL_KEY = 'um_show_all_models';

  // ---------- Toast "ajouté au panier" ----------
  var toastEl = null;
  var toastTimer = null;
  function flashToast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'um-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('um-toast--visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('um-toast--visible'); }, 2200);
  }
  window.umFlashToast = flashToast;

  // ---------- Animation "vol vers le panier" ----------
  // Ajoutée le 02/09 : le formulaire de fiche produit postait nativement vers
  // /cart/add, ce qui renvoyait le client sur la page panier à chaque ajout.
  // On veut au contraire qu'il reste sur la fiche produit, avec un retour
  // visuel clair : un clone de la photo s'envole vers le panier du header.
  function flyToCart(sourceEl, cartEl) {
    if (!sourceEl || !cartEl) return;

    // Respecte prefers-reduced-motion (déjà pris en compte ailleurs sur le
    // site) : on garde juste le petit "bump" du panier, sans l'animation de
    // déplacement.
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      cartEl.classList.add('site-header__cart--bump');
      setTimeout(function () { cartEl.classList.remove('site-header__cart--bump'); }, 320);
      return;
    }

    var srcRect = sourceEl.getBoundingClientRect();
    var cartRect = cartEl.getBoundingClientRect();
    if (!srcRect.width || !cartRect.width) return;

    var clone = sourceEl.cloneNode(true);
    clone.removeAttribute('id');
    clone.className = 'um-fly-clone';
    clone.style.left = srcRect.left + 'px';
    clone.style.top = srcRect.top + 'px';
    clone.style.width = srcRect.width + 'px';
    clone.style.height = srcRect.height + 'px';
    document.body.appendChild(clone);

    var dx = (cartRect.left + cartRect.width / 2) - (srcRect.left + srcRect.width / 2);
    var dy = (cartRect.top + cartRect.height / 2) - (srcRect.top + srcRect.height / 2);

    // Deux requestAnimationFrame : le premier laisse le navigateur peindre le
    // clone à sa position de départ, le second déclenche la transition. Un
    // seul rAF suffit parfois mais pas toujours selon les navigateurs — sans
    // le second, l'animation démarre déjà en position finale.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        clone.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(.08)';
        clone.style.opacity = '0.2';
      });
    });

    var cleaned = false;
    function cleanup() {
      if (cleaned) return;
      cleaned = true;
      if (clone.parentNode) clone.parentNode.removeChild(clone);
      cartEl.classList.add('site-header__cart--bump');
      setTimeout(function () { cartEl.classList.remove('site-header__cart--bump'); }, 320);
    }
    clone.addEventListener('transitionend', cleanup);
    // Filet de sécurité si transitionend ne se déclenche pas (onglet en
    // arrière-plan, navigateur qui saute l'animation, etc.).
    setTimeout(cleanup, 900);
  }
  window.umFlyToCart = flyToCart;

  // ---------- Recherche du header ----------
  function initHeaderSearch() {
    var toggle = document.querySelector('[data-search-toggle]');
    var bar = document.getElementById('HeaderSearch');
    if (!toggle || !bar) return;

    var input = bar.querySelector('[data-search-input]');
    var closeBtn = bar.querySelector('[data-search-close]');

    function open() {
      bar.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      if (input) { input.focus(); input.select(); }
    }
    function close() {
      bar.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      if (bar.hidden) { open(); } else { close(); }
    });

    if (closeBtn) closeBtn.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && !bar.hidden) {
        close();
        toggle.focus();
      }
    });

    // Sur la page résultats, la barre reste ouverte avec le terme recherché.
    if (input && input.value) {
      bar.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
    }
  }

  // ---------- Ajout rapide simple (data-quick-add) ----------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || !window.themeRoutes) return;

    fetch(window.themeRoutes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        btn.textContent = 'Ajouté ✓';
        updateCartCount();
        flashToast('Ajouté au panier');
        setTimeout(function () { btn.textContent = 'Ajouter au panier'; }, 1800);
      })
      .catch(function () {
        btn.textContent = 'Erreur';
      });
  });

  // ---------- Ajout panier depuis le formulaire de fiche produit ----------
  // Ajoutée le 02/09. Le formulaire Liquid `{% form 'product' %}` de
  // sections/main-product.liquid poste nativement vers /cart/add, et Shopify
  // redirige alors le navigateur sur la page panier — c'est le comportement
  // que le client ne voulait pas ("je ne veux pas que quand il clique ça
  // l'envoie à son panier directement"). On intercepte donc la soumission de
  // tout formulaire panier restant (le bouton "kit" et les cartes produit
  // gèrent déjà leur propre ajout AJAX plus haut/dans bundle.js) pour poster
  // en arrière-plan, jouer l'animation de vol vers le panier et rester sur la
  // fiche produit.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    var button = form.querySelector('button[type="submit"]');
    var root = form.closest('[data-product-root]');
    var imgEl = root ? root.querySelector('#ProductMainImage') : null;
    var cartEl = document.querySelector('.site-header__cart');

    if (button) {
      if (!button.dataset.originalText) button.dataset.originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Ajout…';
    }

    fetch((window.themeRoutes && window.themeRoutes.cartAdd) || '/cart/add', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok) {
          flashToast((result.data && result.data.description) || 'Impossible d’ajouter ce produit.');
          return;
        }
        if (imgEl && cartEl) flyToCart(imgEl, cartEl);
        flashToast('Ajouté au panier');
        updateCartCount();
      })
      .catch(function () {
        flashToast('Erreur réseau, réessaie.');
      })
      .then(function () {
        if (button) {
          button.disabled = false;
          button.textContent = button.dataset.originalText;
        }
      });
  });

  // ---------- Quantité sur les product-cards ----------
  // Un seul point d'entrée pour le +, le − et la saisie clavier. On passe par
  // /cart/update.js parce qu'il couvre les trois cas d'un coup : il crée la
  // ligne si le variant n'est pas encore au panier, la met à jour s'il y est,
  // et la supprime à 0. L'ancien code choisissait entre add.js et change.js
  // d'après la valeur affichée dans le champ ; dès que cette valeur était
  // désynchronisée du panier (retour arrière, saisie manuelle), il appelait
  // change.js sur une ligne inexistante et la requête ne faisait rien.
  function cartUpdateUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart/update.js';
  }

  function cartQuantityFor(cart, variantId) {
    var total = 0;
    if (!cart || !cart.items) return total;
    cart.items.forEach(function (item) {
      if (String(item.variant_id) === String(variantId)) total += item.quantity;
    });
    return total;
  }

  function readQty(input) {
    var n = parseInt(input.value, 10);
    if (isNaN(n) || n < 0) n = 0;
    return n;
  }

  function setLineQuantity(wrap, next, previous) {
    var input = wrap.querySelector('[data-qty-input]');
    var variantId = wrap.getAttribute('data-variant-id');
    if (!input || !variantId) return;

    var updates = {};
    updates[variantId] = next;
    wrap.classList.add('is-loading');

    fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        wrap.classList.remove('is-loading');
        // On réaffiche la quantité réellement retenue par le panier plutôt que
        // celle demandée : le stock disponible peut être inférieur.
        var applied = cartQuantityFor(cart, variantId);
        input.value = applied;
        input.dataset.previous = applied;
        renderCart(cart);
        if (applied > previous) flashToast('Ajouté au panier');
      })
      .catch(function () {
        wrap.classList.remove('is-loading');
        input.value = previous;
        input.dataset.previous = previous;
      });
  }

  // Stepper +/-
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    e.preventDefault();
    var wrap = (minus || plus).closest('[data-quick-add-wrap]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-qty-input]');
    if (!input) return;
    var current = readQty(input);
    var next = minus ? Math.max(0, current - 1) : current + 1;
    if (next === current) return;
    input.value = next;
    input.dataset.previous = current;
    setLineQuantity(wrap, next, current);
  });

  // Saisie directe au clavier. Sans cet écouteur, taper une quantité ne
  // modifiait que l'affichage : aucune requête n'était envoyée au panier.
  document.addEventListener('focusin', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    input.dataset.touched = '1';
    input.dataset.previous = readQty(input);
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    // Au rechargement, le navigateur réinjecte les valeurs précédemment
    // saisies et déclenche « change » sans que personne n'ait touché au
    // champ : sans ce garde-fou, la page modifierait le panier toute seule.
    if (!e.isTrusted || input.dataset.touched !== '1') return;
    var wrap = input.closest('[data-quick-add-wrap]');
    if (!wrap) return;
    var previous = parseInt(input.dataset.previous, 10);
    if (isNaN(previous)) previous = 0;
    var next = readQty(input);
    input.value = next;
    if (next === previous) return;
    setLineQuantity(wrap, next, previous);
  });

  // Entrée valide la saisie sans attendre la perte de focus.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    e.preventDefault();
    input.blur();
  });

  // ---------- Bulle panier du header ----------
  // Le montant est reformaté avec le format monétaire de la boutique
  // (window.themeMoneyFormat, posé dans theme.liquid) pour coller au rendu
  // Liquid : €899,00 et non 899,00 €.
  function withDelimiters(value, precision, thousands, decimal) {
    var fixed = Math.abs(value).toFixed(precision);
    var parts = fixed.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+$)/g, '$1' + thousands);
    var out = parts[1] ? whole + decimal + parts[1] : whole;
    return (value < 0 ? '-' : '') + out;
  }

  function formatMoney(cents) {
    var format = window.themeMoneyFormat || '{{amount_with_comma_separator}} €';
    var value = (parseInt(cents, 10) || 0) / 100;

    var text = format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, name) {
      switch (name) {
        case 'amount': return withDelimiters(value, 2, ',', '.');
        case 'amount_no_decimals': return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', ',');
        case 'amount_with_space_separator': return withDelimiters(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return withDelimiters(value, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(value, 2, "'", '.');
        default: return withDelimiters(value, 2, ',', '.');
      }
    });

    // Le format de boutique peut contenir du balisage (<span class="money">…).
    // On n'injecte que du texte dans le header, donc on le retire.
    return text.replace(/<[^>]*>/g, '').trim();
  }

  // Réaligne les champs quantité des cartes sur le panier réel. Indispensable
  // au retour arrière : le navigateur restaure les valeurs saisies et le champ
  // affiche alors une quantité qui n'existe pas dans le panier.
  function syncQtyInputs(cart) {
    var wraps = document.querySelectorAll('[data-quick-add-wrap]');
    Array.prototype.forEach.call(wraps, function (wrap) {
      var input = wrap.querySelector('[data-qty-input]');
      if (!input || input === document.activeElement) return;
      if (wrap.classList.contains('is-loading')) return;
      var qty = cartQuantityFor(cart, wrap.getAttribute('data-variant-id'));
      input.value = qty;
      input.dataset.previous = qty;
    });
  }

  function renderCart(cart) {
    if (!cart) return;
    var counts = document.querySelectorAll('.cart-count, [data-cart-count]');
    Array.prototype.forEach.call(counts, function (el) {
      el.textContent = cart.item_count;
    });
    if (cart.total_price !== undefined && cart.total_price !== null) {
      var totals = document.querySelectorAll('[data-cart-total]');
      Array.prototype.forEach.call(totals, function (el) {
        el.textContent = formatMoney(cart.total_price);
      });
    }
    syncQtyInputs(cart);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  }

  function updateCartCount() {
    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    })
      .then(function (res) { return res.json(); })
      .then(renderCart)
      .catch(function () { /* noop */ });
  }
  window.umRefreshCart = updateCartCount;

  // ---------- Modèle de référence ----------
  function getSavedModel() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null'); } catch (e) { return null; }
  }

  // Ce que le client vient de taper/demander dans l'URL de recherche.
  function searchedTerm() {
    if (window.location.pathname.indexOf('/search') !== 0) return null;
    var m = /[?&]q=([^&]*)/.exec(window.location.search);
    if (!m) return null;
    var q;
    try { q = decodeURIComponent(m[1].replace(/\+/g, ' ')); } catch (e) { return null; }
    q = q.replace(/"/g, '').trim();
    return q || null;
  }

  // Sur la page de recherche, la référence est CE QUE LE CLIENT VIENT DE
  // DEMANDER — pas le véhicule mémorisé dans le garage. Sans ça, une recherche
  // « Rovoron S7 » se faisait commenter au nom d'un tout autre modèle resté
  // dans le garage. Le garage ne sert de référence que hors page de recherche.
  function referenceModel() {
    var term = searchedTerm();
    if (term) return term;
    var saved = getSavedModel();
    return (saved && saved.tag) || null;
  }

  function cardTags(el) {
    return (el.getAttribute('data-compat-tags') || '').split('|');
  }

  function isShowingAll() {
    try { return sessionStorage.getItem(SHOW_ALL_KEY) === '1'; } catch (e) { return false; }
  }

  function setShowingAll(value) {
    try {
      if (value) { sessionStorage.setItem(SHOW_ALL_KEY, '1'); }
      else { sessionStorage.removeItem(SHOW_ALL_KEY); }
    } catch (e) {}
  }

  // ---------- Badges de compatibilité sur les product-cards ----------
  function upgradeCompatBadges() {
    var ref = referenceModel();
    var badges = document.querySelectorAll('[data-compat-badge]');
    badges.forEach(function (el) {
      if (ref && cardTags(el).indexOf(ref) !== -1) {
        el.textContent = '✓ Compatible ' + ref;
        el.classList.add('product-card__fit--match');
      } else {
        el.textContent = el.getAttribute('data-default-text');
        el.classList.remove('product-card__fit--match');
      }
    });
  }

  // ---------- Filtrage des résultats de recherche ----------
  // Une carte n'est masquée QUE si elle déclare des modèles compatibles et que
  // le modèle de référence n'en fait pas partie. Les pièces universelles ou
  // sans donnée de compatibilité restent toujours visibles.
  function filterSearchResults() {
    if (window.location.pathname.indexOf('/search') !== 0) return;

    var grid = document.querySelector('.product-grid');
    if (!grid) return;

    var oldNotice = document.querySelector('[data-compat-filter-notice]');
    if (oldNotice) oldNotice.parentNode.removeChild(oldNotice);

    var ref = referenceModel();
    var cards = grid.querySelectorAll('.product-card');
    cards.forEach(function (card) { card.style.display = ''; });
    if (!ref) return;

    // Garde-fou : si aucune pièce affichée ne connaît ce modèle (recherche par
    // marque, terme libre, faute de frappe…), on ne filtre rien du tout plutôt
    // que de vider la page.
    var matching = 0;
    var offModel = 0;
    var offCards = [];
    cards.forEach(function (card) {
      var badge = card.querySelector('[data-compat-badge]');
      if (!badge) return;
      var tags = cardTags(badge);
      if (tags.indexOf('Universel') !== -1) return;
      if (tags.indexOf(ref) !== -1) { matching++; return; }
      offModel++;
      offCards.push(card);
    });
    if (matching === 0 || offModel === 0) return;

    var showAll = isShowingAll();
    if (!showAll) {
      offCards.forEach(function (card) { card.style.display = 'none'; });
    }

    var notice = document.createElement('p');
    notice.className = 'mono-label collection__compat-notice';
    notice.setAttribute('data-compat-filter-notice', '');
    notice.style.margin = '0 0 16px';

    var label = document.createElement('span');
    if (showAll) {
      label.textContent = offModel > 1
        ? offModel + ' pièces affichées ne sont pas données compatibles ' + ref + '. '
        : offModel + ' pièce affichée n’est pas donnée compatible ' + ref + '. ';
    } else {
      label.textContent = offModel > 1
        ? offModel + ' pièces d’autres modèles masquées. '
        : offModel + ' pièce d’un autre modèle masquée. ';
    }

    var link = document.createElement('button');
    link.type = 'button';
    link.className = 'collection__compat-toggle';
    link.setAttribute('data-compat-filter-toggle', '');
    link.textContent = showAll ? 'Ne garder que ' + ref : 'Tout afficher';
    link.style.background = 'none';
    link.style.border = '0';
    link.style.padding = '0';
    link.style.font = 'inherit';
    link.style.color = 'inherit';
    link.style.textDecoration = 'underline';
    link.style.cursor = 'pointer';

    notice.appendChild(label);
    notice.appendChild(link);
    grid.parentNode.insertBefore(notice, grid);
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-compat-filter-toggle]');
    if (!toggle) return;
    e.preventDefault();
    setShowingAll(!isShowingAll());
    filterSearchResults();
  });

  document.addEventListener('DOMContentLoaded', function () {
    upgradeCompatBadges();
    filterSearchResults();
    initHeaderSearch();
    updateCartCount();
  });

  // Retour arrière depuis le cache navigateur : le HTML restitué date de la
  // visite précédente, on resynchronise la bulle panier.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) updateCartCount();
  });
})();
